



























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import HandleGuestForm from "./HandleGuestForm.vue";
import { db, firestore } from "@/scripts/firebase";
import { JinroPlayerParams } from "@/services/paramstypes";
import { collectionName } from "@/services/collection-name";
import { JinroPlayerDocument } from "../../../services/datatypes";
import ChangeDisplayNameButton from "@/components/shared/ChangeDisplayNameButton.vue";
import { DialogProgrammatic as Dialog } from "buefy";
import JoinPublicViewing from "@/components/JinroRoom/ManageJinroPlayers/JoinPublicViewing.vue";

@Component({
  components: {
    HandleGuestForm,
    ChangeDisplayNameButton,
    JoinPublicViewing
  }
})
export default class HandleLoggedinPlayer extends Vue {
  @Prop() readonly buttonType!: string;
  @Prop() readonly isRedirectAfterAdded!: boolean;
  @Prop() readonly isPublicViewingButtonAllowed!: boolean;

  get players(): Array<JinroPlayerDocument> {
    if (this.$store.state.jinroRoomPlayers) {
      return this.$store.state.jinroRoomPlayers;
    }
    return [];
  }

  get uid(): string {
    if (this.$store.state.firebaseUser) {
      return this.$store.state.firebaseUser.uid;
    }

    return "";
  }

  get user(): JinroPlayerDocument | null {
    if (this.players) {
      const user = this.players.find(player => {
        return player.uid === this.uid;
      }) as JinroPlayerDocument;
      return user;
    }

    return null;
  }

  get userName(): string {
    if (this.$store.state.user) {
      return this.$store.state.user.displayName;
    }
    return "";
  }

  get isUserAlreadyJoined(): boolean {
    if (this.user) {
      return true;
    }

    return false;
  }

  async handleUserJoin() {
    Dialog.confirm({
      message: "ゲームに参加しますか？",
      cancelText: "キャンセル",
      confirmText: "ゲームに参加する",
      onConfirm: () => this.userJoin()
    });
  }

  async userJoin() {
    const hasAlreadyJoinedBefore = await this.getHasAlreadyJoinedBefore();
    if (!hasAlreadyJoinedBefore) {
      const playerParams: JinroPlayerParams = {
        uid: this.uid,
        isGuest: false,
        isDeleted: false,
        playerName: this.$store.state.user.displayName,
        jinroRoomId: this.$route.params.jinroRoomId,
        timeCreated: firestore.FieldValue.serverTimestamp()
      };
      await db
        .collection(collectionName.jinrorooms)
        .doc(this.$route.params.jinroRoomId)
        .collection(collectionName.jinroplayers)
        .add({
          ...playerParams
        });
    }

    if (this.isRedirectAfterAdded) {
      const player = this.getUserPlayer;
      if (player === null) {
        return;
      }
      this.friendlyDialogue(player);
    }
  }

  friendlyDialogue(userPlayer: JinroPlayerDocument) {
    Dialog.confirm({
      message: "プレイヤー画面に移動します。",
      canCancel: false,
      confirmText: `プレイヤー「 ${userPlayer.playerName}」画面に移動する`,
      onConfirm: () => this.$router.push(`/p/${userPlayer.id}`)
    });
  }

  get getUserPlayer(): JinroPlayerDocument | null {
    if (!this.$store.state.jinroRoomPlayers) {
      return null;
    }
    const players = this.$store.state.jinroRoomPlayers as Array<
      JinroPlayerDocument
    >;
    const player = players.find(pl => {
      return pl.uid === this.uid;
    });
    if (!player) {
      return null;
    }
    return player;
  }

  async getHasAlreadyJoinedBefore(): Promise<boolean> {
    const ref = db
      .collection(collectionName.jinrorooms)
      .doc(this.$route.params.jinroRoomId)
      .collection(collectionName.jinroplayers)
      .where("uid", "==", this.uid)
      .orderBy("timeCreated", "desc");

    const snapshot = await ref.get();
    if (snapshot.empty) {
      return false;
    }

    const ids = snapshot.docs.map(doc => {
      return doc.id;
    });

    const displayName = this.$store.state.user.displayName;
    await db
      .collection(collectionName.jinrorooms)
      .doc(this.$route.params.jinroRoomId)
      .collection(collectionName.jinroplayers)
      .doc(ids[0])
      .set(
        {
          playerName: displayName,
          isDeleted: false,
          timeUpdated: firestore.FieldValue.serverTimestamp()
        },
        { merge: true }
      );

    return true;
  }

  async handleUserCancel() {
    if (!this.user) {
      return;
    }
    const playerId = this.user.id;
    Dialog.confirm({
      message: "ゲームの参加をやめますか？",
      type: "is-danger",
      cancelText: "キャンセル",
      confirmText: "ゲームの参加をやめる",
      onConfirm: () => this.userCancel(playerId)
    });
  }

  async userCancel(playerId: string) {
    await db
      .collection(collectionName.jinrorooms)
      .doc(this.$route.params.jinroRoomId)
      .collection(collectionName.jinroplayers)
      .doc(playerId)
      .set(
        {
          isDeleted: true,
          timeUpdated: firestore.FieldValue.serverTimestamp()
        },
        { merge: true }
      );
  }
}
